import {
    STATIONS_REQUEST,
    STATIONS_SUCCESS,
    STATIONS_ERROR,
    
    STATIONS_2_REQUEST,
    STATIONS_2_SUCCESS,
    STATIONS_2_ERROR,
  
    STATIONSTATUS_REQUEST,
    STATIONSTATUS_SUCCESS,
    STATIONSTATUS_ERROR,

    FUELS_REQUEST,
    FUELS_SUCCESS,
    FUELS_ERROR,
    
  } from "../actions/stations";

import { AUTH_LOGOUT } from "../actions/auth";
import Vue from "vue";
import HTTP from "@/utils/http.js";

const state = {
    stations_get_status: "",
    stations_once_loaded: false,
    stations: [],

    stationstatus_get_status: "",
// -------------------------------------
    stations2_get_status: "",
    stations2_once_loaded: false,
    stations2: [],

    station2status_get_status: "",
// -------------------------------------
    fuels: [],
    fuels_get_status: "",
    fuels_once_loaded: false,
}

const getters = {
    getStations: state => state.stations,
    getStationsById: state => id => state.stations.find(s => s.id == id),
    //getStationsCount: state => state.cards ? state.cards.length : 0,
    stationsLoaded: state => state.stations_get_status,
    isStationsLoading: state => state.stations_get_status === 'loading',

    stationsOnceLoaded: state => state.stations_once_loaded,

    getStationStatus_result: state => state.stationstatus_get_status, 
// -------------------------------------
    getStations2: state => state.stations2,
    isStations2Loading: state => state.stations2_get_status === 'loading',

    stations2OnceLoaded: state => state.stations2_once_loaded,
// -------------------------------------
    fuelsOnceLoaded: state => state.fuels_once_loaded,
    isFuelsLoading: state => state.fuels_get_status === 'loading',
    getFuels: state => state.fuels,
    getFuelById: state => id => state.fuels.find(f => f.id == id),
}

const actions = {
    [STATIONS_REQUEST]: ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {  
        commit(STATIONS_REQUEST);
        HTTP({ url: "stations/config" })
          .then(resp => {
            console.log(resp.data);
            commit(STATIONS_SUCCESS, resp.data);
            resolve(resp);
          })
          .catch((err) => {
            commit(STATIONS_ERROR);
              if (err.status === 401) {
                dispatch(AUTH_LOGOUT);
              }
            reject(err);
          });
      });
    },
    [STATIONS_2_REQUEST]: ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
        commit(STATIONS_2_REQUEST);
        HTTP({ url: "stations" })
          .then(resp => {
            commit(STATIONS_2_SUCCESS, resp.data);
            console.log(resp.data);
            resolve(resp);
          })
          .catch((err) => {
            commit(STATIONS_2_ERROR);
            if (err.status === 401) {
              dispatch(AUTH_LOGOUT);
            }
            reject(err);
          });
        });
      },


    [STATIONSTATUS_REQUEST]: ({ commit, dispatch}, station ) => {
      return new Promise((resolve, reject) => {
        commit(STATIONSTATUS_REQUEST);
        HTTP({ 
              url: "stations/status", 
              data: {"station_id": station.id},
              method: "POST" 
            })
          .then(resp => {
            commit(STATIONSTATUS_SUCCESS, resp.data)
            resolve(resp);
          })
          .catch((err) => {
            commit(STATIONSTATUS_ERROR);
            if (err.status === 401) {
              dispatch(AUTH_LOGOUT);
            }
            reject(err);
          });
      })
    },
  
    [FUELS_REQUEST]: ({ commit, dispatch }) => {
      commit(FUELS_REQUEST);
      return new Promise((resolve, reject) => {  
        HTTP({ url: "products" })
              .then(resp => {
                commit(FUELS_SUCCESS, resp.data);
                console.log(resp.data);
                resolve(resp);
              })
              .catch((err) => {
                commit(FUELS_ERROR);
                if (err.status === 401) {
                  dispatch(AUTH_LOGOUT);
                reject(err);
              }
              });
        });    }
 
}

const mutations = {
    [STATIONS_REQUEST]: state => {
      state.stations_get_status = "loading";
    },
    [STATIONS_SUCCESS]: (state, data) => {
      state.stations_get_status = "success";
      Vue.set(state, "stations", data);
      state.stations_once_loaded = true;
    },
    [STATIONS_ERROR]: state => {
      state.stations_get_status = "error";
      state.stations_once_loaded = true;
    },
// -------------------------------------
    [STATIONS_2_REQUEST]: state => {
      state.stations2_get_status = "loading";
    },
    [STATIONS_2_SUCCESS]: (state, data) => {
      state.stations2_get_status = "success";
      Vue.set(state, "stations2", data);
      state.stations2_once_loaded = true;
    },
    [STATIONS_2_ERROR]: state => {
      state.stations2_get_status = "error";
      state.stations2_once_loaded = true;
    },
// -------------------------------------
    [STATIONSTATUS_REQUEST]: state => {
      state.stationstatus_get_status = "loading";      
    },
    [STATIONSTATUS_SUCCESS]: state => {
      state.stationstatus_get_status = "success";
    },
    [STATIONSTATUS_ERROR]: state => {
      state.stationstatus_get_status = "error";
    },
// -------------------------------------
    [FUELS_REQUEST]: state => {
      state.fuels_get_status = "loading";      
    },
    [FUELS_SUCCESS]: (state, data) => {
      state.fuels_get_status = "success";
      Vue.set(state, "fuels", data);
      state.fuels_once_loaded = true;
    },
    [FUELS_ERROR]: state => {
      state.fuels_get_status = "error";
    },
}  


export default {
    state,
    getters,
    actions,
    mutations
  };